import validationRules from '../../../utilities/validationRules';
import wellnessProgramPaymentResources from '../wellnessProgramPaymentsResources';

export const partnerRequired = validationRules.required(
    wellnessProgramPaymentResources.labelPartner
);

export const visitMonthRequired = validationRules.required(
    wellnessProgramPaymentResources.labelVisitMonth
);

export const forPartnerRequired = validationRules.required(
    wellnessProgramPaymentResources.labelForPartner
);

export const periodRequired = validationRules.required(
    wellnessProgramPaymentResources.labelForUsagePeriod
);